import { render, staticRenderFns } from "./NoUserFound.vue?vue&type=template&id=35cd9324&scoped=true"
import script from "./NoUserFound.vue?vue&type=script&lang=js"
export * from "./NoUserFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cd9324",
  null
  
)

export default component.exports